<template lang="html">
<b-container fluid>
    <b-row>
        <b-col md="4" offset-md="4" align-self="center"  d-flex h-100 flex-wrap >
          <b-img src="../assets/480x320-blade.png" center fluid alt="Responsive image" style=" margin-top:5%"/>
          <b-card title=""  sub-title="" style=" margin-top:3%">
            <p class="blade-blue">Thank you for using StrinGnosis® Online. Your streaming session has successfully ended.</p>
            <p class="blade-blue">If your session ended abruptly after starting, it may be due to insufficient available seats in your user pool to continue the session.</p>
            <p class="blade-blue">Should you have any questions, please contact our Support team at <a href="mailto:support@stringnosis.com">support@stringnosis.com</a></p>
            <p><button v-on:click="navigateToHomePage" class="btn btn-lg btn-blade btn-block">Login</button></p>
            <div class="loader"> <stretch v-if="busy" ></stretch> </div>
          </b-card>
        </b-col>
    </b-row>
    <div slot="footer" class="w-100">
      <license-footer></license-footer>
    </div>
 </b-container>
</template>

<script lang="js">

import LicenseFooter from './LicenseFooter'
import { Stretch } from 'vue-loading-spinner'

export default {
  name: 'select-instance',
  components: {
    Stretch,
    LicenseFooter
  },
  props: [],
  mounted: async function () {
    const self = this

  },
  data () {
    return {
      errorMsg: '',
      hasError: false,
      busy: false
    }
  },
  methods: {
    navigateToHomePage () {
      this.$router.push('/')
    }
  },
  computed: {

  }
}
</script>

<style src="../assets/styles.css"></style>



// WEBPACK FOOTER //
// src/components/EndSessionNotification.vue